import type { ReqSystemSafety } from '../models/system-safety.model';
import type { ReqSystemSave, ReqSystemUpdate } from '../models/system.model';

/**
 * System Safety 관련 Query Keys
 *
 * @description
 * 안전교육 시스템 설정 관련 query-key들을 관리합니다.
 */
export const systemSafetyKeys = {
  QUERY_KEY_SYSTEM_SAFETY: (data: ReqSystemSafety) => [
    'systemSafety',
    'getSystemList',
    JSON.stringify(data)
  ],
  QUERY_KEY_SAVE_SYSTEM_CODE: (data: ReqSystemSave) => [
    'systemSafety',
    'saveSystemCode',
    JSON.stringify(data)
  ],
  QUERY_KEY_UPDATE_SYSTEM_CODE: (data: ReqSystemUpdate) => [
    'systemSafety',
    'updateSystemCode',
    JSON.stringify(data)
  ],
  QUERY_KEY_GET_SYSTEM_LIST_BY_RANGE: (data: { clsCdStart?: number; clsCdLast?: number }) => [
    'systemSafety',
    'getSystemListByRange',
    JSON.stringify(data)
  ],
  QUERY_KEY_DELETE_SYSTEM_CODE: (systemId: string) => ['systemSafety', 'deleteSystemCode', systemId]
};
